import React from "react";

export const ProductDetailsInStockBannerIcon = ()=>{
    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="9" fill="#77A22A"/>
    <path d="M5 9.5L7.5 12L13.5 6" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
    
}